<template>
  <plugin-dialog
    v-if="plan"
    :isVisible="isDialogVisible"
    @update:isVisible="onDialogInput"
  >
    <template #content>
      <div class="my-modal__title">
        <div class="total-apartments">{{ plan.roomsAmount }}-к {{ plan.areaRange.min }} м<sup>2</sup></div>
      </div>
      <div class="my-modal__items">
        <ul class="flat-items">
          <li class="flat-items__li"
            v-if="isRoomsNumberVisible"
          ><span class="flat-item-title">Количество комнат</span><span class="item-val">{{ plan.roomsAmount }}</span></li>
          <li class="flat-items__li"><span class="flat-item-title">Этаж</span><span class="item-val">{{ flat.value.floor }}</span></li>
          <li class="flat-items__li"><span class="flat-item-title">Площадь</span><span class="item-val">{{ plan.areaRange.min }} м<sup>2</sup></span></li>
          <li class="flat-items__li"><span class="flat-item-title">Номер</span><span class="item-val">{{ flat.value.number }}</span></li>
          <li style="display: none;" class="flat-items__li flat-items__li_bedroom"><span class="flat-item-title">Спальня</span><span class="item-val">-</span></li>
          <li style="opacity: 0" class="flat-items__li flat-items__li_bathroom"><span class="flat-item-title">Санузел</span><span class="item-val">-</span></li>
        </ul>
      </div>
      <div class="my-modal__price flex-grow-1">
        <div class="price-block">
          <div class="price-block__text price-text">Цена</div>
          <div class="price-block__lower">
            <div class="item-price item-price--medium">
              <span v-bind:style="{ opacity: price ? 1 : 0 }">{{ price }} ₽</span>
            </div>
          </div>
        </div>
      </div>
      <div class="my-modal__btn">
        <div class="modal-btn">
          <div class="modal-btn__item">
            <button class="my-btn" style="width: 100%;"
              @click="onLink"
            >Получить консультацию</button>
          </div>
          <div class="modal-btn__item mb-0 d-none">
            <button class="save-btn" style="width: 100%;"
              @click="onDownload"
            >
              <svg width="23" height="26" class="save-btn__icon" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.28613 2.71441C3.28613 1.76766 4.0538 1 5.00054 1H15.287C15.6025 1 15.8585 1.25582 15.8585 1.57154C15.8585 1.88706 15.6025 2.14288 15.287 2.14288H5.00054C4.68502 2.14288 4.42901 2.39889 4.42901 2.71441V13.0009C4.42901 13.3164 4.17318 13.5724 3.85767 13.5724C3.54196 13.5724 3.28613 13.3164 3.28613 13.0009V2.71441ZM22.1447 7.85764C22.4602 7.85764 22.7162 8.11347 22.7162 8.42918V17.5724C22.7162 17.8881 22.4602 18.1439 22.1447 18.1439C21.8291 18.1439 21.5731 17.8881 21.5731 17.5724V8.42918C21.5731 8.11347 21.8291 7.85764 22.1447 7.85764ZM22.1447 20.4302C22.4602 20.4302 22.7162 20.686 22.7162 21.0015V23.2874C22.7162 24.2342 21.9485 25.0019 21.0018 25.0019H6.14322C5.8277 25.0019 5.57188 24.746 5.57188 24.4303C5.57188 24.1148 5.82771 23.859 6.14322 23.859H21.0018C21.3173 23.859 21.5731 23.603 21.5731 23.2874V21.0015C21.5731 20.686 21.8291 20.4302 22.1447 20.4302Z" fill="#E4943D" stroke="#E4943D" stroke-width="0.5"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0687 1.04346C15.2823 0.955058 15.5281 1.00404 15.6916 1.16744L22.5492 8.02509C22.7126 8.18849 22.7614 8.43437 22.673 8.64791C22.5846 8.86145 22.3762 9.00055 22.1451 9.00055H16.4302C15.4835 9.00055 14.7158 8.23308 14.7158 7.28614V1.57176C14.7158 1.34062 14.8551 1.13225 15.0687 1.04367L15.0687 1.04346ZM15.859 2.95111V7.28612C15.859 7.60183 16.1148 7.85765 16.4303 7.85765H20.7655L15.859 2.95111Z" fill="#E4943D" stroke="#E4943D" stroke-width="0.5"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 16.4299C1 16.1144 1.25602 15.8584 1.57154 15.8584H3.28595C4.23269 15.8584 5.00036 16.6261 5.00036 17.5728C5.00036 18.5198 4.23269 19.2872 3.28595 19.2872H2.14307V21.0016C2.14307 21.3173 1.88706 21.5732 1.57154 21.5732C1.25602 21.5732 1 21.3173 1 21.0016V16.4299ZM2.14307 18.1443H3.28595C3.60147 18.1443 3.85748 17.8885 3.85748 17.5728C3.85748 17.2573 3.60147 17.0015 3.28595 17.0015H2.14307V18.1443Z" fill="#E4943D" stroke="#E4943D" stroke-width="0.5"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.71484 16.4299C6.71484 16.1144 6.97067 15.8584 7.28638 15.8584H8.42925C10.0072 15.8584 11.2865 17.1377 11.2865 18.7159C11.2865 20.2939 10.0072 21.5732 8.42925 21.5732H7.28638C6.97067 21.5732 6.71484 21.3173 6.71484 21.0016V16.4299ZM7.85772 17.0015V20.4303H8.42925C9.376 20.4303 10.1437 19.6626 10.1437 18.7159C10.1437 17.7689 9.376 17.0015 8.42925 17.0015H7.85772Z" fill="#E4943D" stroke="#E4943D" stroke-width="0.5"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.001 16.4299C13.001 16.1144 13.257 15.8584 13.5725 15.8584H16.4298C16.7455 15.8584 17.0013 16.1144 17.0013 16.4299C17.0013 16.7455 16.7455 17.0015 16.4298 17.0015H14.144V18.7159H15.8585C16.174 18.7159 16.4298 18.9717 16.4298 19.2872C16.4298 19.6029 16.174 19.8588 15.8585 19.8588H14.144V21.0016C14.144 21.3173 13.888 21.5732 13.5725 21.5732C13.257 21.5732 13.001 21.3173 13.001 21.0016V16.4299Z" fill="#E4943D" stroke="#E4943D" stroke-width="0.5"></path>
              </svg>
              Скачать план
            </button>
          </div>
        </div>
      </div>

      <!-- <div style="flex-grow: 1;"></div>

      <div v-if="isFlatParkingType">
        <p style="font-size: 9px;">
          <span>*цена распространяется при приобретении квартиры в жилом комплексе Меркурий</span>
        </p>
      </div> -->
    </template>

    <template #preview>
      <img class="flat-selection-img" alt=""
        :src="plan.image.big"
      >
    </template>
  </plugin-dialog>
</template>

<script>
  import PluginDialog from '@/modules/plugin/components/PluginDialog'

  import { isVisible, hide, show } from '@/modules/plugin/components/PluginDialog/state'
  
  import { token } from '@/shared/axios/profitbase/store'

  import { ref } from '@vue/reactivity'

  import { presetList } from '../state'

  import profitbaseReguestService from '@/shared/requests/profitbaseReguestService'

  export default {
    props: {
      flat: {
        type: [ Object, null ]
      }
    },
    
    components: { PluginDialog },

    setup() {
      const plan = ref( null )
      
      const onLink = () => {
        const el = document.querySelector( 'a[href="#popup:myform"]' )
        if ( el ) el.click()
        hide()
      }

      const onDialogInput = value => value ? show() : hide()

      return {
        onLink,
        isDialogVisible: isVisible, onDialogInput,
        token,
        plan,
        presetList,
        price: ref( null )
      }
    },

    methods: {
      onDownload() {
        const link = document.createElement( 'a' )
        link.href = `${ process.env.VUE_APP_HOST_ROOT }${ process.env.VUE_APP_PROFITBASE_API_USER }/pdf/${ this.flat.value.id }`
        link.target = '_blank'
        document.body.appendChild( link )
        link.click() 
        link.remove()
      }
    },

    mounted() {
      this.plan = this.presetList.find( el => el.properties ? el.properties.includes( `${ this.flat.value.id }` ) : false )

      if ( this.flat.value.house_id == 99685 ) {
        const price = this.flat.value.custom_fields?.find( el => el?.id === 'property_price' )?.value
        this.price = new Intl.NumberFormat().format( price )
      }
      else {
        profitbaseReguestService.getPropertyList( { token: this.token, id: this.flat.value.id, full: true } )
          .then( response => {
            const price = response?.data?.data[ 0 ]?.custom_fields?.find( el => el?.id === 'property_price' )?.value
            this.price = price ? new Intl.NumberFormat().format( price ) : null
          } )
      }
    },

    computed: {
      isRoomsNumberVisible() {
        return !this.isFlatParkingType
      },

      isFlatParkingType() {
        return this.flat.value.typePurpose === 'parking'
      },

      name() {
        const result = this.isFlatParkingType
          ? `Машиноместо ${ this.flat.value.number }`
          : this.plan.code
        return result
      }
    }
  }
</script>

<style scoped>
  .flat-items__li.flat-items__li_bedroom, .flat-items__li.flat-items__li_bathroom {
    opacity: 0;
  }

  .flat-selection-img {
    max-height: 430px;
    object-fit: contain;
  }
</style>